{
    "Profile_Dwellings.dwellings": "Dwellings",
    "Profile_Dwellings.dwelling": "Dwelling {number}"
}
